import { Flex, Link, Text } from '@radix-ui/themes'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Button, Callout } from '~/elementsv2'
import { IntegrationDetails } from '~/features/integrations/components'
import { useFeature } from '~/hooks'
import { useMakeIntegrationPublic } from '~/hooks/integrations/useMakeIntegrationPublic'
import { integrationQueryOptions } from '~/queries'
import { showConfirmationDialog } from '~/services'

export const Route = createFileRoute('/workspaces/$workspaceId/integrations/$integrationId/')({
  component: Component,
})

function Component() {
  const { integrationId, workspaceId } = Route.useParams()
  const integration = useSuspenseQuery(integrationQueryOptions({ integrationId, workspaceId })).data
  const { mutate: publishIntegration, isPending: publishingIntegration } = useMakeIntegrationPublic({
    workspaceId,
    integrationId,
  })

  const canMakePublic = useFeature('integrations.publish') && !integration.public
  return (
    <Flex direction={'column'} gap={'2'}>
      <Callout
        calloutAction={
          canMakePublic ? (
            <Button
              className="self-center"
              variant="ghost"
              loading={publishingIntegration}
              onClick={() =>
                showConfirmationDialog({
                  confirmLabel: 'Yes',
                  cancelLabel: 'Cancel',
                  onConfirm: publishIntegration,
                  title: `Publish ${integration.name} to Botpress Hub`,
                  content: (
                    <Text>
                      Are you sure you want to make {integration?.name} public? All users will be able to install it in
                      their chatbots.
                      <br />
                      <strong>This action cannot be undone</strong>.
                    </Text>
                  ),
                })
              }
            >
              Make Public
            </Button>
          ) : (
            <Link target="_blank" href="https://botpress.com/docs/developers/publishing-to-botpress-hub/">
              <Button className="self-center" variant="ghost">
                Make Public
              </Button>
            </Link>
          )
        }
      >
        <Text size={'2'} color={'blue'}>
          This is a&nbsp;
          <strong>{integration?.public ? 'public' : 'private'}</strong>&nbsp;integration.
        </Text>
      </Callout>
      <IntegrationDetails integration={integration} />
    </Flex>
  )
}
